import { action, observable, makeObservable } from "mobx";
import getCookie from "../utils/getCookie";
import setCookie from "../utils/setCookie";

import PopupElement from "./models/PopupElement";

const defaultBrowsers = {
  chrome: 109, // текущая версия на 26.04.24 - 124.
  edge: -1, // не поддерживаем
  opera: 100, // текущая версия на 26.04.24 - 109.
  firefox: 110, // текущая версия на 26.04.24 - 125.
  edg: 110, // текущая версия на 26.04.24 - 123.
  ie: -1, // не поддерживаем
  yandex: 15, // текущая версия на 26.04.24 - 24.
  version: 13,
};

class OutdatedBrowser {
  constructor(rootStore, baseUrl) {
    makeObservable(this, {
      showOutdatedBrowserPopup: observable,
      currentBrowser: observable,
      setOutdatedBrowserPopupVisibility: action,
      setCurrentBrowser: action,
      checkOutdatedBrowserPopupVisibility: action,
    });

    this.rootStore = rootStore;
    this.baseUrl = baseUrl;

    this.outdatedBrowserPopup = new PopupElement({
      name: "outdatedBrowserPopup",
      eventType: "internal",
      priority: "important",
      position: "center",
      openCallback: this.addOutdatedBrowserPopupToQueue,
      custom: true,
    });
  }

  showOutdatedBrowserPopup = false;

  currentBrowser = "";

  setOutdatedBrowserPopupVisibility = (value) => {
    this.showOutdatedBrowserPopup = value;
  };

  addOutdatedBrowserPopupToQueue = () => {
    this.setOutdatedBrowserPopupVisibility(true);
  };

  handleBrowserInformerClose = () => {
    setCookie("outdatedBrowserInformer", true, {
      domain: window.location.hostname.replace(/.*(.ati\.s.*)/g, "$1"),
      expires: 3,
    });

    this.setOutdatedBrowserPopupVisibility(false);
    this.rootStore.popupController.handlePopupClose(this.outdatedBrowserPopup);
  };

  detectBrowser = () => {
    // переводит в нижний регистр, чтобы было проще обрабатывать и использовать
    const userAgent = navigator.userAgent.toLowerCase();
    let browser;
    // вытаскиваем все что похоже на основные платформы
    const foundMatches =
      userAgent.match(
        /(opera|chrome|version|firefox|edge|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];

    if (/(trident|msie)/i.test(foundMatches[1])) {
      browser = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return { browserName: "ie", version: browser[1] || "" };
    }

    // если в userAgent встречается chrome, то это браузер основанный на нем
    // нужно уточнить какой именно и вернуть ответ
    if (foundMatches[1] === "chrome") {
      browser = userAgent.match(/\b(opr|edge|edg|yabrowser)\/(\d+)/);
      if (browser !== null) {
        const browserName = browser[1]
          .replace("opr", "opera")
          .replace("yabrowser", "yandex");
        return { browserName, version: browser[2] };
      }
    }

    // во всех остальных случаях возвращаем название и версию без разбора если удалось разобрать
    if (foundMatches.length > 0) {
      return { browserName: foundMatches[1], version: foundMatches[2] };
    }

    // если не удалось, ничего не возвращаем
    return { browserName: null, version: null };
  };

  setCurrentBrowser = (value) => {
    this.currentBrowser = value;
  };

  checkOutdatedBrowserPopupVisibility = () => {
    // не показываем на мобилках и если проставлена кука
    if (window.innerWidth < 1024 || getCookie("outdatedBrowserInformer")) {
      return;
    }

    const browserInformation = this.detectBrowser();

    if (defaultBrowsers[browserInformation.browserName]) {
      const preferredVersion = defaultBrowsers[browserInformation.browserName];

      // Мы приравниваем edge и ie. Если выпал один из этих браузеров - обрабатываем одинаково.
      if (
        browserInformation.browserName === "ie" ||
        browserInformation.browserName === "edge"
      ) {
        this.setCurrentBrowser("ie");
        this.rootStore.popupController.addPopupToQueue(
          this.outdatedBrowserPopup
        );
        return;
      }

      if (browserInformation.version < preferredVersion) {
        this.setCurrentBrowser(browserInformation.browserName);
        this.rootStore.popupController.addPopupToQueue(
          this.outdatedBrowserPopup
        );
      }
    }
  };
}

export default OutdatedBrowser;
